module.exports = __webpack_public_path__ + "static/media/iconWsp.86f37744.svg";